import {
  CreditVetting,
  DealsForFTTHS,
  DeliveryAddress,
  DealGrid,
  Error,
  ExternalTermsAndConditionLink,
  FinalizeOrder,
  NewCustomerDocumentNotes,
  NewCustomerSuccessScreen,
  CustomerFalloutScreen,
  NewPlanDetails,
  PersonalInformation,
  PortalLogIn,
  CustomerApproval,
  CustomerApprovalNewCustomer,
  Quotation,
  ReviewOrder,
  TrackSalesOrder,
  UploadDocuments,
  VumaContactInformation,
  VumaPlanDetails,
  VumaSuccessScreen,
  SuccessScreen
} from 'src/UI';

export { default as NavLayoutRouteWrapper } from './components/NavLayoutRouteWrapper';

export const Routes = {
  ChoosePlan: {
    component: DealGrid,
    exact: true,
    page: 'ChoosePlan',
    path: '/cloud/fibre/sales/choosePlan'
  },
  CustomerApproval: {
    component: CustomerApproval,
    exact: true,
    page: 'CustomerApproval',
    path: '/cloud/fibre/sales/CustomerApproval'
  },
  CustomerApprovalNewCustomer: {
    component: CustomerApprovalNewCustomer,
    exact: true,
    page: 'CustomerApprovalNewCustomer',
    path: '/cloud/fibre/sales/CustomerApprovalNewCustomer'
  },
  CreditVetting: {
    component: CreditVetting,
    exact: true,
    page: 'CreditVetting',
    path: '/cloud/fibre/sales/credit-vetting'
  },
  DealsForFTTHS: {
    component: DealsForFTTHS,
    exact: true,
    page: 'DealsForFTTHS',
    path: '/cloud/fibre/sales/fibre-deals'
  },
  DeliveryAddress: {
    component: DeliveryAddress,
    exact: true,
    page: 'DeliveryAddress',
    path: '/cloud/fibre/sales/deliveryAddress'
  },
  // EmployerDetails: {
  //   component: ReviewOrder,
  //   exact: true,
  //   page: 'EmployerDetails',
  //   path: '/cloud/fibre/sales/employerDetails'
  // },
  Error: {
    component: Error,
    exact: true,
    page: 'Error',
    path: '/cloud/fibre/sales/error'
  },
  ExternalTermsAndConditionLink: {
    component: ExternalTermsAndConditionLink,
    exact: true,
    page: 'ExternalTermsAndConditionLink',
    path: '/cloud/fibre/sales/extTermsAndConditionLink'
  },
  FinalizeOrder: {
    component: FinalizeOrder,
    exact: true,
    page: 'FinalizeOrder',
    path: '/cloud/fibre/sales/finalizeOrder'
  },
  NewCustomerDocumentNotes: {
    component: NewCustomerDocumentNotes,
    exact: true,
    page: 'NewCustomerDocumentNotes',
    path: '/cloud/fibre/sales/document-notes'
  },
  NewCustomerSuccessScreen: {
    component: NewCustomerSuccessScreen,
    exact: true,
    page: 'NewCustomerSuccessScreen',
    path: '/cloud/fibre/sales/confirmation'
  },
  CustomerFalloutScreen: {
    component: CustomerFalloutScreen,
    exact: true,
    page: 'CustomerFalloutScreen',
    path: '/cloud/fibre/sales/leadConfirmation'
  },
  PersonalInformation: {
    avoidHeaders: true,
    component: PersonalInformation,
    exact: true,
    page: 'PersonalInformation',
    path: '/cloud/fibre/sales/contactInformation'
  },
  PlanDetails: {
    component: NewPlanDetails,
    exact: true,
    page: 'PlanDetails',
    path: '/cloud/fibre/sales/planDetails'
  },
  PortalLogIn: {
    component: PortalLogIn,
    exact: true,
    page: 'PortalLogIn',
    path: '/cloud/fibre/sales/portal/log-in'
  },
  // Quotation: {
  //   component: Quotation,
  //   exact: true,
  //   page: 'Quotation',
  //   path: '/cloud/fibre/sales/quotation'
  // },
  ReviewOrder: {
    component: ReviewOrder,
    exact: true,
    page: 'ReviewOrder',
    path: '/cloud/fibre/sales/review-order'
  },
  SalesLeads: {
    component: DealGrid,
    exact: true,
    page: 'SalesLeads',
    path: '/cloud/fibre/sales/leads'
  },
  SalesOrder: {
    component: DealGrid,
    exact: true,
    page: 'SalesOrder',
    path: '/cloud/fibre/sales/order'
  },
  SuccessScreen: {
    component: SuccessScreen,
    exact: true,
    page: 'SuccessScreen',
    path: '/cloud/fibre/sales/success'
  },
  TrackSalesOrder: {
    component: TrackSalesOrder,
    exact: true,
    page: 'TrackSalesOrder',
    path: '/cloud/fibre/sales/trackSalesOrder'
  },
  UploadDocuments: {
    component: UploadDocuments,
    exact: true,
    page: 'UploadDocuments',
    path: '/cloud/fibre/sales/upload-documents'
  },
  VumaContactInformation: {
    component: VumaContactInformation,
    exact: true,
    page: 'VumaContactInformation',
    path: '/cloud/fibre/sales/vumaContactInformation'
  },
  VumaPlanDetails: {
    component: VumaPlanDetails,
    exact: true,
    page: 'VumaPlanDetails',
    path: '/cloud/fibre/sales/vumatelPlanDetails'
  },
  Screen: {
    component: VumaSuccessScreen,
    exact: true,
    page: 'VumaSuccessScreen',
    path: '/cloud/fibre/sales/success-vuma'
  }
};
